module.exports = __webpack_public_path__ + "static/media/portfolio1.5595b442.jpg";